/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react'
import { DataContext } from '../../context/DataContext'
import { t } from '../../i18n/i18n'
import { Grid } from '../common/grid/Grid'
import { Activity } from '../../api/schemas/schema'
import { useForm } from 'react-hook-form'
import { deleteActivity, getDefaultValues, onActivitySubmit } from '../../helpers/calendarHelper'
import { ActivityForm } from './ActivityForm'
import { DraggableModal } from '../common/modal/DraggableModal'
import { MoreOptionsMenuButton } from '../common/other/MoreOptionsMenuButton'
import { isSystemAdmin } from '../../helpers/permissionHelper'
import { Form } from '../common/form/Form'

type ModalActivityProps = {
   modalState: {
      isOpen: boolean
      selectedActivity?: Activity
   }
   setActivities: React.Dispatch<React.SetStateAction<Activity[]>>
   setModalState: React.Dispatch<
      React.SetStateAction<{
         isOpen: boolean
         selectedActivity?: Activity
      }>
   >
   currentYear: number
}

export const ModalActivity = ({ modalState, setActivities, setModalState, currentYear }: ModalActivityProps) => {
   const dataContext = useContext(DataContext)
   const { userAccount } = dataContext.state
   const selectedActivity = modalState?.selectedActivity
   const activityForm = useForm<Activity>({})
   const { reset, handleSubmit } = activityForm

   useEffect(() => {
      getDefaultValues(reset, selectedActivity)
   }, [selectedActivity, reset])

   const onClose = () => {
      setModalState({ isOpen: false, selectedActivity: undefined })
      reset()
   }

   const onSubmit = async (data: Activity) => {
      onActivitySubmit(dataContext, data, setActivities, onClose, currentYear, modalState?.selectedActivity)
   }

   const deleteOptions = () => {
      const userHasPermission = isSystemAdmin(userAccount)

      const deleteDisabled = !userHasPermission
      const deleteTooltipMessage = t('OnlySystemAdministratorCanDeleteActivities')

      return (
         <MoreOptionsMenuButton
            item={selectedActivity}
            deleteFunction={deleteActivity}
            setState={setActivities}
            disabled={deleteDisabled}
            disabledToolTipMessage={deleteTooltipMessage}
            deleteMessage={t('DeleteItem', { Item: t('Activity').toLowerCase() })}
            deleteConfirmationMessage={t('DeleteItemConfirmationMessage', { Item: t('TheActivity').toLowerCase() })}
            closeOnDelete={onClose}
         />
      )
   }

   return (
      <>
         <DraggableModal
            title={selectedActivity ? t('EditActivity') : t('PlanActivity')}
            open={modalState.isOpen}
            onClose={onClose}
            secondaryButton={selectedActivity ? deleteOptions : undefined}
         >
            <Form onSubmit={handleSubmit(onSubmit)}>
               <Grid>
                  <ActivityForm activityForm={activityForm} modalState={modalState} onClose={onClose} />
               </Grid>
            </Form>
         </DraggableModal>
      </>
   )
}
